import { Avatar } from "../Avatar";
import { TypingIndicator } from "../TypingIndicator";

import { SystemMessageContainer } from "./styled";

export interface IndicatorProps {
  avatar: string;
  containerStyle?: React.CSSProperties;
}

export const Indicator: React.FC<IndicatorProps> = ({
  avatar,
  containerStyle = {},
}) => (
  <SystemMessageContainer $withImage $center style={containerStyle}>
    <Avatar avatar={avatar} size="small" />
    <TypingIndicator />
  </SystemMessageContainer>
);
